// Перед выкладкой в прод заменить тестовые ID ниже на ID из справочника прода.
// Где взять countryId: в DevTools → Network найти GET /api/v1/directories/countries/ru
// (тот же запрос выполняет Order.getCountries("ru")). В ответе найти нужную страну
// по name и скопировать её id: это значение хранится в order.addressList[].countryId.
// Если у страны несколько записей, добавить все соответствующие ID.
// В тестовом справочнике пока нет ID следующих исключённых стран:
// Украина, Израиль, Палестинские территории, Иран, Сирия, Йемен, Ирак,
// Афганистан и Пакистан. Проверить их в проде и добавить найденные ID в этот список.
const excludedCountryIds = new Set([
  "63556bc1614a6ddc9ceeb61f", // Россия
  "680780bfd478958ebe20082c", // Россия (вторая запись справочника)
  "680780bfd478958ebe200830", // Ливан
  "680780bfd478958ebe200828", // Мьянма
]);

export const hasExcludedInsuranceTerritory = (addressList) =>
  Array.isArray(addressList) && addressList.some((address) => excludedCountryIds.has(address?.countryId));
